import { Box, Flex, Stack, StackProps } from '@chakra-ui/react';

import { CustomHeading } from 'shared-components';

interface ISidebarGroup extends StackProps {
  header?: string | React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export const SidebarGroup = (props: ISidebarGroup) => {
  const { header, actions, children } = props;

  return (
    <Stack
      spacing={0}
      px={{ base: 6, '2xl': 8, '3xl': 10 }}
      py={3}
      borderBottomWidth={1}
      _last={{
        borderBottomWidth: 0,
      }}
      {...props}
    >
      {header && (
        <Flex alignItems="start">
          <CustomHeading as="h3" level="h5" mb={0} py={2} isAllCaps>
            {header}
          </CustomHeading>

          {actions && <Box ml={'auto'}>{actions}</Box>}
        </Flex>
      )}

      {children}
    </Stack>
  );
};
